import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { ForgotPasswordComponent } from 'app/login/components/forgot-password/forgot-password.component';
declare var ga: any;

@Component({
  selector: 'app-forgot-password-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent,ForgotPasswordComponent],
  templateUrl: './forgot-password-section.component.html',
  styleUrls: ['./forgot-password-section.component.scss'],
  providers: [ErrorHandler]
})
export class ForgotPasswordSectionComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/forgot-password');
      ga('send', 'pageview');
    }
  }

}
